export const translations = {
  en: {
    // Header
    appTitle: "Kolkata Pandals",
    appSubtitle: "Durga Puja 2025",
    
    // Navigation
    pandals: "Pandals",
    metro: "Metro",
    help: "Help",
    aiChat: "AI Chat",
    
    // Stats
    votes: "votes",
    areas: "areas",
    metroGuide: "Metro Guide",
    
    // Filter
    searchPlaceholder: "Search pandals...",
    allAreas: "All Areas",
    mostPopular: "Most Popular",
    leastPopular: "Least Popular",
    nameAZ: "Name A-Z",
    nameZA: "Name Z-A",
    showing: "Showing",
    of: "of",
    pandalsFound: "pandals",
    
    // Pandal Card
    timings: "Timings",
    nearestMetro: "Nearest Metro",
    line: "Line",
    instagrammable: "Instagrammable",
    proTip: "Pro Tip",
    viewOnMaps: "View on Maps",
    shareThisPandal: "Share This Pandal",
    share: "Share",
    navigate: "Navigate",
    reel: "Reel",
    noReelAvailable: "No reel available",
    reelComingSoon: "Reel coming soon!",
    close: "Close",
    viewOnInstagram: "View on Instagram",
    watchReelOnInstagram: "Watch this reel on Instagram",
    lowCrowd: "Low Crowd",
    moderate: "Moderate",
    highCrowd: "High Crowd",
    
    // Metro Guide
    kolkataMetroNetwork: "Kolkata Metro Network",
    metroDescription: "Explore the metro network and find the best routes to reach your favorite pandals.",
    interactiveMetroMap: "Interactive Metro Map",
    metroMapComingSoon: "Metro Map Coming Soon!",
    metroMapDescription: "Interactive metro map with pandal locations will be available here.",
    stationsNearPandals: "Stations Near Pandals",
    metroTravelTips: "Metro Travel Tips",
    peakHours: "Peak Hours",
    peakHoursDesc: "Avoid 8-10 AM and 6-8 PM for less crowded travel",
    smartCard: "Smart Card",
    smartCardDesc: "Use smart cards for faster entry and discounts",
    metroTimings: "Timings",
    metroTimingsDesc: "Metro runs from 6:45 AM to 9:45 PM daily",
    
    // Help Section
    emergencyContacts: "Emergency Contacts",
    medicalEmergency: "Medical Emergency",
    ambulanceHelp: "Ambulance & Medical Help",
    emergencyAmbulance: "Emergency Ambulance",
    medicalEmergencyNumber: "Medical Emergency",
    policeSecurity: "Police & Security",
    lawEnforcement: "Law Enforcement",
    policeEmergency: "Police Emergency",
    womenHelpline: "Women Helpline",
    durgaPujaHelplines: "Durga Puja Helplines",
    kolkataMunicipal: "Kolkata Municipal Corporation",
    pandalInfoSupport: "Pandal Information & Support",
    kolkataMetro: "Kolkata Metro",
    metroInfoSupport: "Metro Information & Support",
    touristInformation: "Tourist Information",
    westBengalTourism: "West Bengal Tourism",
    touristInfoSupport: "Tourist Information & Support",
    publicTransport: "Public Transport",
    busTransportInfo: "Bus & Transport Information",
    quickSafetyTips: "Quick Safety Tips",
    keepEmergencyNumbers: "Keep Emergency Numbers Handy",
    keepEmergencyDesc: "Save all emergency contacts in your phone",
    stayInGroups: "Stay in Groups",
    stayInGroupsDesc: "Avoid visiting pandals alone, especially at night",
    shareLocation: "Share Your Location",
    shareLocationDesc: "Let family know which pandals you're visiting",
    reportSuspicious: "Report Suspicious Activity",
    reportSuspiciousDesc: "Call 100 immediately if you see anything suspicious",
    
    // AI Chatbot
    aiPandalAssistant: "AI Pandal Assistant",
    poweredByGemini: "Powered by Gemini AI",
    askAboutPandals: "Ask about pandals, routes, timings...",
    aiThinking: "AI is thinking...",
    
    // Favorites
    myFavorites: "My Favorite Pandals",
    noFavoritesYet: "No Favorites Yet",
    startExploring: "Start exploring pandals and tap the heart icon to add them to your favorites!",
    explorePandals: "Explore Pandals",
    exploreMore: "Explore More",
    pandalsSaved: "pandals saved",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    viewFavorites: "View Favorites",
    
    // Welcome Screen
    welcomeTitle: "Welcome to Utsav Oorja",
    welcomeSubtitle: "Discover the Magic of Durga Puja 2025",
    welcomeDescription: "Explore beautiful pandals, find metro routes, and create your perfect Puja experience",
    getStarted: "Get Started",
    madeWithLove: "Made with ❤️ for Kolkata's Durga Puja",
    interactiveMetroMap: "Interactive Metro Map",
    aiPandalAssistant: "AI-Powered Pandal Assistant",
    multilingualSupport: "Multilingual Support",
    favoritesSharing: "Favorites & Sharing",
    
    // Common
    loading: "Loading",
    error: "Error",
    noResults: "No pandals found",
    tryAdjusting: "Try adjusting your search criteria or filters.",
    addPandals: "Add some pandals to your Firestore database to get started.",
    clearFilters: "Clear Filters",
  },
  
  hi: {
    // Header
    appTitle: "कोलकाता पंडाल",
    appSubtitle: "दुर्गा पूजा 2025",
    
    // Navigation
    pandals: "पंडाल",
    metro: "मेट्रो",
    help: "सहायता",
    aiChat: "AI चैट",
    
    // Stats
    votes: "वोट",
    areas: "क्षेत्र",
    metroGuide: "मेट्रो गाइड",
    
    // Filter
    searchPlaceholder: "पंडाल खोजें...",
    allAreas: "सभी क्षेत्र",
    mostPopular: "सबसे लोकप्रिय",
    leastPopular: "कम लोकप्रिय",
    nameAZ: "नाम A-Z",
    nameZA: "नाम Z-A",
    showing: "दिखा रहे हैं",
    of: "का",
    pandalsFound: "पंडाल",
    
    // Pandal Card
    timings: "समय",
    nearestMetro: "निकटतम मेट्रो",
    line: "लाइन",
    instagrammable: "इंस्टाग्राम योग्य",
    proTip: "प्रो टिप",
    viewOnMaps: "मैप्स पर देखें",
    shareThisPandal: "इस पंडाल को साझा करें",
    share: "साझा करें",
    navigate: "नेविगेट करें",
    reel: "रील",
    noReelAvailable: "कोई रील उपलब्ध नहीं",
    reelComingSoon: "रील जल्द आ रही है!",
    close: "बंद करें",
    viewOnInstagram: "इंस्टाग्राम पर देखें",
    watchReelOnInstagram: "इंस्टाग्राम पर इस रील को देखें",
    lowCrowd: "कम भीड़",
    moderate: "मध्यम",
    highCrowd: "अधिक भीड़",
    
    // Metro Guide
    kolkataMetroNetwork: "कोलकाता मेट्रो नेटवर्क",
    metroDescription: "मेट्रो नेटवर्क का अन्वेषण करें और अपने पसंदीदा पंडालों तक पहुंचने के लिए सबसे अच्छे रास्ते खोजें।",
    interactiveMetroMap: "इंटरैक्टिव मेट्रो मैप",
    metroMapComingSoon: "मेट्रो मैप जल्द आ रहा है!",
    metroMapDescription: "पंडाल स्थानों के साथ इंटरैक्टिव मेट्रो मैप यहां उपलब्ध होगा।",
    stationsNearPandals: "पंडालों के पास स्टेशन",
    metroTravelTips: "मेट्रो यात्रा सुझाव",
    peakHours: "भीड़ के समय",
    peakHoursDesc: "कम भीड़ के लिए सुबह 8-10 बजे और शाम 6-8 बजे से बचें",
    smartCard: "स्मार्ट कार्ड",
    smartCardDesc: "तेज प्रवेश और छूट के लिए स्मार्ट कार्ड का उपयोग करें",
    metroTimings: "समय",
    metroTimingsDesc: "मेट्रो रोजाना सुबह 6:45 से रात 9:45 तक चलती है",
    
    // Help Section
    emergencyContacts: "आपातकालीन संपर्क",
    medicalEmergency: "चिकित्सा आपातकाल",
    ambulanceHelp: "एम्बुलेंस और चिकित्सा सहायता",
    emergencyAmbulance: "आपातकालीन एम्बुलेंस",
    medicalEmergencyNumber: "चिकित्सा आपातकाल",
    policeSecurity: "पुलिस और सुरक्षा",
    lawEnforcement: "कानून प्रवर्तन",
    policeEmergency: "पुलिस आपातकाल",
    womenHelpline: "महिला हेल्पलाइन",
    durgaPujaHelplines: "दुर्गा पूजा हेल्पलाइन",
    kolkataMunicipal: "कोलकाता नगर निगम",
    pandalInfoSupport: "पंडाल जानकारी और सहायता",
    kolkataMetro: "कोलकाता मेट्रो",
    metroInfoSupport: "मेट्रो जानकारी और सहायता",
    touristInformation: "पर्यटक जानकारी",
    westBengalTourism: "पश्चिम बंगाल पर्यटन",
    touristInfoSupport: "पर्यटक जानकारी और सहायता",
    publicTransport: "सार्वजनिक परिवहन",
    busTransportInfo: "बस और परिवहन जानकारी",
    quickSafetyTips: "त्वरित सुरक्षा सुझाव",
    keepEmergencyNumbers: "आपातकालीन नंबर हाथ में रखें",
    keepEmergencyDesc: "अपने फोन में सभी आपातकालीन संपर्क सेव करें",
    stayInGroups: "समूह में रहें",
    stayInGroupsDesc: "रात में, विशेष रूप से अकेले पंडाल देखने से बचें",
    shareLocation: "अपना स्थान साझा करें",
    shareLocationDesc: "परिवार को बताएं कि आप कौन से पंडाल देख रहे हैं",
    reportSuspicious: "संदिग्ध गतिविधि की रिपोर्ट करें",
    reportSuspiciousDesc: "कुछ भी संदिग्ध दिखे तो तुरंत 100 पर कॉल करें",
    
    // AI Chatbot
    aiPandalAssistant: "AI पंडाल सहायक",
    poweredByGemini: "Gemini AI द्वारा संचालित",
    askAboutPandals: "पंडाल, रूट, समय के बारे में पूछें...",
    aiThinking: "AI सोच रहा है...",
    
    // Favorites
    myFavorites: "मेरे पसंदीदा पंडाल",
    noFavoritesYet: "अभी तक कोई पसंदीदा नहीं",
    startExploring: "पंडालों का अन्वेषण शुरू करें और उन्हें अपने पसंदीदा में जोड़ने के लिए हृदय आइकन पर टैप करें!",
    explorePandals: "पंडालों का अन्वेषण करें",
    exploreMore: "और अन्वेषण करें",
    pandalsSaved: "पंडाल सेव किए गए",
    addToFavorites: "पसंदीदा में जोड़ें",
    removeFromFavorites: "पसंदीदा से हटाएं",
    viewFavorites: "पसंदीदा देखें",
    
    // Welcome Screen
    welcomeTitle: "उत्सव उर्जा में आपका स्वागत है",
    welcomeSubtitle: "दुर्गा पूजा 2025 का जादू खोजें",
    welcomeDescription: "सुंदर पंडालों का अन्वेषण करें, मेट्रो रूट खोजें, और अपना सही पूजा अनुभव बनाएं",
    getStarted: "शुरू करें",
    madeWithLove: "कोलकाता की दुर्गा पूजा के लिए ❤️ से बनाया गया",
    interactiveMetroMap: "इंटरैक्टिव मेट्रो मैप",
    aiPandalAssistant: "AI-संचालित पंडाल सहायक",
    multilingualSupport: "बहुभाषी समर्थन",
    favoritesSharing: "पसंदीदा और साझाकरण",
    
    // Common
    loading: "लोड हो रहा है",
    error: "त्रुटि",
    noResults: "कोई पंडाल नहीं मिला",
    tryAdjusting: "अपने खोज मानदंड या फिल्टर को समायोजित करने का प्रयास करें।",
    addPandals: "शुरू करने के लिए अपने Firestore डेटाबेस में कुछ पंडाल जोड़ें।",
    clearFilters: "फिल्टर साफ करें",
  },
  
  bn: {
    // Header
    appTitle: "কলকাতা প্যান্ডেল",
    appSubtitle: "দুর্গা পূজা ২০২৫",
    
    // Navigation
    pandals: "প্যান্ডেল",
    metro: "মেট্রো",
    help: "সাহায্য",
    aiChat: "AI চ্যাট",
    
    // Stats
    votes: "ভোট",
    areas: "এলাকা",
    metroGuide: "মেট্রো গাইড",
    
    // Filter
    searchPlaceholder: "প্যান্ডেল খুঁজুন...",
    allAreas: "সব এলাকা",
    mostPopular: "সবচেয়ে জনপ্রিয়",
    leastPopular: "কম জনপ্রিয়",
    nameAZ: "নাম A-Z",
    nameZA: "নাম Z-A",
    showing: "দেখানো হচ্ছে",
    of: "এর",
    pandalsFound: "প্যান্ডেল",
    
    // Pandal Card
    timings: "সময়",
    nearestMetro: "নিকটতম মেট্রো",
    line: "লাইন",
    instagrammable: "ইনস্টাগ্রাম যোগ্য",
    proTip: "প্রো টিপ",
    viewOnMaps: "ম্যাপে দেখুন",
    shareThisPandal: "এই প্যান্ডেল শেয়ার করুন",
    share: "শেয়ার করুন",
    navigate: "নেভিগেট করুন",
    reel: "রিল",
    noReelAvailable: "কোনো রিল পাওয়া যায়নি",
    reelComingSoon: "রিল শীঘ্রই আসছে!",
    close: "বন্ধ করুন",
    viewOnInstagram: "ইনস্টাগ্রামে দেখুন",
    watchReelOnInstagram: "ইনস্টাগ্রামে এই রিলটি দেখুন",
    lowCrowd: "কম ভিড়",
    moderate: "মাঝারি",
    highCrowd: "অধিক ভিড়",
    
    // Metro Guide
    kolkataMetroNetwork: "কলকাতা মেট্রো নেটওয়ার্ক",
    metroDescription: "মেট্রো নেটওয়ার্ক অন্বেষণ করুন এবং আপনার প্রিয় প্যান্ডেলগুলিতে পৌঁছানোর সেরা রুট খুঁজুন।",
    interactiveMetroMap: "ইন্টারঅ্যাক্টিভ মেট্রো ম্যাপ",
    metroMapComingSoon: "মেট্রো ম্যাপ শীঘ্রই আসছে!",
    metroMapDescription: "প্যান্ডেল অবস্থান সহ ইন্টারঅ্যাক্টিভ মেট্রো ম্যাপ এখানে উপলব্ধ হবে।",
    stationsNearPandals: "প্যান্ডেলের কাছে স্টেশন",
    metroTravelTips: "মেট্রো ভ্রমণ টিপস",
    peakHours: "ভিড়ের সময়",
    peakHoursDesc: "কম ভিড়ের জন্য সকাল ৮-১০টা এবং সন্ধ্যা ৬-৮টা এড়িয়ে চলুন",
    smartCard: "স্মার্ট কার্ড",
    smartCardDesc: "দ্রুত প্রবেশ এবং ছাড়ের জন্য স্মার্ট কার্ড ব্যবহার করুন",
    metroTimings: "সময়",
    metroTimingsDesc: "মেট্রো প্রতিদিন সকাল ৬:৪৫ থেকে রাত ৯:৪৫ পর্যন্ত চলে",
    
    // Help Section
    emergencyContacts: "জরুরি যোগাযোগ",
    medicalEmergency: "চিকিৎসা জরুরি",
    ambulanceHelp: "অ্যাম্বুলেন্স এবং চিকিৎসা সহায়তা",
    emergencyAmbulance: "জরুরি অ্যাম্বুলেন্স",
    medicalEmergencyNumber: "চিকিৎসা জরুরি",
    policeSecurity: "পুলিশ এবং নিরাপত্তা",
    lawEnforcement: "আইন প্রয়োগ",
    policeEmergency: "পুলিশ জরুরি",
    womenHelpline: "মহিলা হেল্পলাইন",
    durgaPujaHelplines: "দুর্গা পূজা হেল্পলাইন",
    kolkataMunicipal: "কলকাতা পৌরসংস্থা",
    pandalInfoSupport: "প্যান্ডেল তথ্য এবং সহায়তা",
    kolkataMetro: "কলকাতা মেট্রো",
    metroInfoSupport: "মেট্রো তথ্য এবং সহায়তা",
    touristInformation: "পর্যটন তথ্য",
    westBengalTourism: "পশ্চিমবঙ্গ পর্যটন",
    touristInfoSupport: "পর্যটন তথ্য এবং সহায়তা",
    publicTransport: "সরকারি পরিবহন",
    busTransportInfo: "বাস এবং পরিবহন তথ্য",
    quickSafetyTips: "দ্রুত নিরাপত্তা টিপস",
    keepEmergencyNumbers: "জরুরি নম্বর হাতে রাখুন",
    keepEmergencyDesc: "আপনার ফোনে সব জরুরি যোগাযোগ সংরক্ষণ করুন",
    stayInGroups: "দলে থাকুন",
    stayInGroupsDesc: "রাতে, বিশেষ করে একা প্যান্ডেল দেখতে এড়িয়ে চলুন",
    shareLocation: "আপনার অবস্থান শেয়ার করুন",
    shareLocationDesc: "পরিবারকে জানান আপনি কোন প্যান্ডেল দেখছেন",
    reportSuspicious: "সন্দেহজনক কার্যকলাপ রিপোর্ট করুন",
    reportSuspiciousDesc: "কিছু সন্দেহজনক দেখলে অবিলম্বে ১০০ নম্বরে কল করুন",
    
    // AI Chatbot
    aiPandalAssistant: "AI প্যান্ডেল সহায়ক",
    poweredByGemini: "Gemini AI দ্বারা চালিত",
    askAboutPandals: "প্যান্ডেল, রুট, সময় সম্পর্কে জিজ্ঞাসা করুন...",
    aiThinking: "AI চিন্তা করছে...",
    
    // Favorites
    myFavorites: "আমার প্রিয় প্যান্ডেল",
    noFavoritesYet: "এখনো কোনো প্রিয় নেই",
    startExploring: "প্যান্ডেল অন্বেষণ শুরু করুন এবং সেগুলিকে আপনার প্রিয় তালিকায় যোগ করতে হৃদয় আইকনে ট্যাপ করুন!",
    explorePandals: "প্যান্ডেল অন্বেষণ করুন",
    exploreMore: "আরো অন্বেষণ করুন",
    pandalsSaved: "প্যান্ডেল সংরক্ষিত",
    addToFavorites: "প্রিয় তালিকায় যোগ করুন",
    removeFromFavorites: "প্রিয় তালিকা থেকে সরান",
    viewFavorites: "প্রিয় দেখুন",
    
    // Welcome Screen
    welcomeTitle: "উৎসব উর্জায় স্বাগতম",
    welcomeSubtitle: "দুর্গা পূজা ২০২৫ এর জাদু আবিষ্কার করুন",
    welcomeDescription: "সুন্দর প্যান্ডেল অন্বেষণ করুন, মেট্রো রুট খুঁজুন, এবং আপনার নিখুঁত পূজা অভিজ্ঞতা তৈরি করুন",
    getStarted: "শুরু করুন",
    madeWithLove: "কলকাতার দুর্গা পূজার জন্য ❤️ দিয়ে তৈরি",
    interactiveMetroMap: "ইন্টারঅ্যাক্টিভ মেট্রো ম্যাপ",
    aiPandalAssistant: "AI-চালিত প্যান্ডেল সহায়ক",
    multilingualSupport: "বহুভাষিক সমর্থন",
    favoritesSharing: "প্রিয় এবং শেয়ারিং",
    
    // Common
    loading: "লোড হচ্ছে",
    error: "ত্রুটি",
    noResults: "কোনো প্যান্ডেল পাওয়া যায়নি",
    tryAdjusting: "আপনার অনুসন্ধান মানদণ্ড বা ফিল্টার সামঞ্জস্য করার চেষ্টা করুন।",
    addPandals: "শুরু করতে আপনার Firestore ডেটাবেসে কিছু প্যান্ডেল যোগ করুন।",
    clearFilters: "ফিল্টার সাফ করুন",
  }
};
